interface TopBannerProps {
  children: React.ReactNode;
}

/**
 * Simple sticky top banner used across views to house context switchers or
 * status messages.  Tailored for the in-session dashboard prototype.
 */
export default function TopBanner({ children }: TopBannerProps) {
  return (
    <div className="sticky top-0 z-20 flex items-center justify-between gap-4 bg-surface py-2 px-4 shadow-sm">
      {children}
    </div>
  );
}
